import React,{useState,useEffect} from 'react';
import {Card,Input,Button} from '../../components/';
import FormatDate from '../../Utils/Date/FormatDate';
import {Redirect} from 'react-router-dom';
import {connect} from 'react-redux';

const Profile = ({connection,tokenObject}) => {

    const [Pass,setPass] = useState("");
    const [ConfirmPass,setConfirmPass] = useState("");
    const [OldPass,setOldPass] = useState("");
    const [User,setUser] = useState({});
    const [wasSuccededMessage,setWasSuccededMessage] = useState("");

    useEffect(async () =>{
        if(User.statusCode === undefined){
            const result = await connection.get('/User',{
                headers:{
                    'user-access-token':tokenObject.token
                }
            });
            setUser({...result.data,statusCode:result.status});    
        }
    });

    function handlePass(event){
        setPass(event.target.value);
    }

    function handleConfirmPass(event){
        setConfirmPass(event.target.value);
    }

    function handleOldPass(event){
        setOldPass(event.target.value);
    }

    function isPassConfirmed(){
        return Pass === ConfirmPass;
    }

    function isPassEmpty(Pass){
        return Pass === ""
    }

    async function UpdatePassword(){

        if(isPassEmpty(OldPass)) return;
        if(isPassEmpty(Pass)) return;
        if(!isPassConfirmed()) return;
        
        const Result = await connection.post("/User/Upd/PW",{
            OldPassword:OldPass,
            Password:Pass
        },{
            headers:{
                'user-access-token':tokenObject.token
            }
        });

        if(Result.n === 1){
            setWasSuccededMessage("Password successfully changed!");
        }

        if(Result.n === 1){
            setWasSuccededMessage("Password successfully changed!");
        }
        
    }
    

    if(tokenObject.token === ""){
        return(
            <Redirect to="/Home"/>
        )
    }
    return(
        <Card>
            <br/>
                {(() => {
                    return wasSuccededMessage !== ""? (<div class="alert alert-success" role="alert">
                    {wasSuccededMessage}
                </div>) : (<></>)
                })()}
                <center><h1>Perfil</h1></center>
                <br/>
                <Card>
                    <h4>Username</h4>
                    <p>{User.User}</p>
                </Card>
                <br/>
                <Card>
                    <h4>E-mail</h4>
                    <p>{User.Email}</p>
                </Card>
                <br/>
                <Card>
                    <h4>Creation Date</h4>
                    <p>{(() => {
                        if(User.statusCode !== undefined){
                            return FormatDate(User.Created_at);
                        }
                    })()}</p>
                </Card>
                <br/>
                <Card>
                    <h4>Password</h4>
                        <label>Old Password</label>
                        <Input type="Password" id = "InputOldPass" onKeyUp={handleOldPass}/>
                        <label>New Password</label>
                        <Input type="Password" id = "InputPass" onKeyUp={handlePass}/>
                        <br/>
                        <label>Confirm Password</label>
                        <Input type="Password" id = "InputConfirmPass" onKeyUp={handleConfirmPass}/>
                        <br/>
                        <Button type="Primary" onClick={UpdatePassword}>Change Password</Button>
                </Card>
        </Card>
    )
}

const mapStateToProps = (state) => ({
    tokenObject: state.token
});


export default connect(mapStateToProps)(Profile);